import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCCgMz9LGKwOWAtuW5FjpkXLxlgWkfljA0",
  authDomain: "p2pdigital.firebaseapp.com",
  projectId: "p2pdigital",
  storageBucket: "p2pdigital.firebasestorage.app",
  messagingSenderId: "406205817734",
  appId: "1:406205817734:web:7249f4de347650b50fc207",
  measurementId: "G-PVVD0Y00RR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

export { app, analytics, auth }; 